import React from 'react'
import ReactDOM from 'react-dom/client'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'

import App from './App'
import { msalConfig } from './azureB2C/authConfig'

import './index.scss'
import { interceptor } from './services/api.service'

import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

import datadogService from './services/datadog.service'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

export const msalInstance = new PublicClientApplication(msalConfig)

interceptor()
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
)

const cookieConsent = localStorage.getItem('cookiefirst-consent')
const analyticsConsent = JSON.parse(cookieConsent || "{}")
if ((analyticsConsent.performance && process.env.REACT_APP_ENV === 'production') || process.env.REACT_APP_ENV === 'uat' || process.env.REACT_APP_ENV === 'development') {
  datadogService.rum.init()
}

export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
